


































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import UnitModel from '@/_models/UnitModel'

@Component({
  components: {},
})
export default class SearchUnit extends Vue {
  // Props
  @Prop()
  private selectedData!: any

  // data
  private isPaginated: boolean = true
  private isPaginationSimple: boolean = false
  private paginationPosition: string = 'bottom'
  private defaultSortDirection: string = 'asc'
  private sortIcon: string = 'arrow-up'
  private sortIconSize: string = 'is-small'
  private currentPage: number = 1
  private perPage: number = 10
  private numofPage: number = 1
  private selected: any = {}
  private isFormModalActive: boolean = false
  private isSearchCatActive: boolean = false
  private isSearchCardActive: boolean = false
  private searchQuery: string = ''
  private selectedFilter: string = 'name'
  private filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.unit_name',
    customer_name: 'label.customer_name',
    address: 'label.address',
  }

  // computed
  get units(): UnitModel[] {
    const units = this.$store.state.units.all.items
    this.numofPage = Math.ceil(units.length / this.perPage)

    return units
  }

  get isLoading(): boolean {
    return this.$store.state.units.loading
  }

  get filteredData(): UnitModel[] {
    const targetField: string = this.selectedFilter
    if (!this.units) {
      return []
    }

    return this.units.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  // methods
  private convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  // Handle methods
  private handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      name: this.selected.name || '',
    }

    this.$emit('selectedUnitDone', selectedData)
  }

  // After page created
  private created() {
    this.$store.dispatch('units/getAll').then(() => {
      for (const item of this.filteredData) {
        if (
          typeof this.selectedData !== 'undefined' &&
          this.selectedData &&
          item._id === this.selectedData._id
        ) {
          this.selected = item
          return
        }
      }
    })
  }
}
